import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import { ChromePicker } from "react-color";
import {ComponentContext} from "../../contexts";
import reactionCombiner from "../../utils/reactionCombiner";
import DataExporter from "../Helpers/DataExporter";

function Color(props) {
  let _onWindowClick=(e)=>{
    let inside=false;
    e.composedPath().forEach((item)=>{
      if(item.classList && (item.classList.contains("chrome-picker") || item.classList.contains("pickIniter"))) {
        inside=true;
      }
    });

    if(!inside) {
      runInAction(()=>{
        store.cp_visible=false;
      });
      // this._pickerRef._closeCalendar();
    }
  };

  const store = useLocalObservable(() => ({
    comb:null,
    cp_visible:false
  }));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount
    if(!store.comb) {
      store.comb = new reactionCombiner();
      store.comb.addReaction(()=>{
        return getValue().ob_value;
      }, (v)=>{
        if(
          typeof v.r !== 'undefined' &&
          typeof v.g !== 'undefined' &&
          typeof v.b !== 'undefined' &&
          typeof v.a !== 'undefined'
        ) {
          getValue().value = `rgba(${v.r}, ${v.g}, ${v.b}, ${v.a})`;
        } else {
          getValue().value = "";
        }
      });
      store.comb.addReaction(()=>{
        return getValue().value;
      }, (strValue)=>{
        if(strValue) {
          let arr=strValue.split("(")[1].split(")")[0].split(",");
          arr=arr.map((item)=>{
            return parseFloat(item.trim());
          });
          const rgb={
            r:arr[0],
            g:arr[1],
            b:arr[2],
            a:arr[3]
          };
          if(
            !getValue().ob_value ||
            getValue().ob_value.r !== rgb.r ||
            getValue().ob_value.g !== rgb.g ||
            getValue().ob_value.b !== rgb.b ||
            getValue().ob_value.a !== rgb.a
          ) {
            runInAction(()=>{
              getValue().ob_value=rgb;
            });
          }
        } else {
          getValue().ob_value={};
        }
      },{ fireImmediately:true });
      store.comb.addReaction(()=>{
        return store.cp_visible;
      }, (visible)=>{
        if(visible) {
          document.addEventListener("click", _onWindowClick);
        } else {
          document.removeEventListener("click", _onWindowClick);
        }
      });
    }

    return () => {
      store.comb.clear();
      document.removeEventListener("click",this._onWindowClick);
      // unmount
    }
  }, []);

  const getValue=()=>{
    if(typeof props.index === "undefined") {
      if(typeof compStore.data.ob_value === "undefined" && typeof compStore.data.value === "undefined") {
        compStore.data={ob_value:"", value:""};
      }
      return compStore.data;
    } else {
      if(typeof compStore.data.value[props.index] === "undefined") {
        compStore.data[props.index]={ob_value:"", value: ""};
      }
      return compStore.data[props.index];
    }
  };

  const clearValue=()=>{
    runInAction(()=>{
      getValue().ob_value={};
      getValue().value="";
      // compStore.data={ob_value:"", value:""};
    });
  };

  return (
    <div className="pr">
      <div className="up12 splice">
        <div className="cell s-shrink">
          <div style={{width:50, height:30, background:'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}} className="pickIniter padd5 solid1 bo-w3 pointer" onClick={()=>{ runInAction(()=>{ store.cp_visible=!store.cp_visible; }); }}>
            <div style={{width:5-12, height: 30-12, backgroundColor:getValue().value}}></div>
          </div>
        </div>
        {getValue().value?(
          <div className="cell s-shrink padd5 s-middle pointer" onClick={()=>{ clearValue(); }}>
            <span className="mdi mdi-close b1"></span>
          </div>
        ):null}
      </div>


      <div className={`pa ${store.cp_visible?"":"dn"}`} style={{left:0, bottom:'100%', zIndex:10000}}>
        <ChromePicker
          color={getValue().ob_value}
          onChange={(color)=>{
            runInAction(()=>{
              getValue().ob_value=color.rgb;
            });
          }}
        />
      </div>
      {typeof props.index === "undefined"?(
        <DataExporter exportIndex="value" rawValue={true} />
      ):null}
    </div>
  )
};

Color.defaultProps = {};

Color.propTypes = {}

export default observer(Color);
